module.exports = __webpack_public_path__ + "img/madagascar.27b7d8ad.svg";